import { render, staticRenderFns } from "./saas_auth_config.vue?vue&type=template&id=e5513d48&scoped=true"
import script from "./saas_auth_config.vue?vue&type=script&lang=js"
export * from "./saas_auth_config.vue?vue&type=script&lang=js"
import style0 from "./saas_auth_config.vue?vue&type=style&index=0&id=e5513d48&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5513d48",
  null
  
)

export default component.exports